import { useEffect, useRef, useState } from "react";
import { api } from "../api";
import { createSearch, emptySearch } from "../search";

interface Props {
  onResult: (kind: "tx" | "account" | "round", id: string) => void;
}

export default function SearchBar({ onResult }: Props) {
  const [q, setQ] = useState("");
  const [state, setState] = useState(emptySearch);
  const onSelect = useRef(onResult);
  onSelect.current = onResult;
  const [search] = useState(() => createSearch(api.search, setState, (match) => {
    onSelect.current(match.kind, match.id);
  }));
  useEffect(() => search.cancel, [search]);

  const clear = () => { search.cancel(); setState(emptySearch()); };
  return (
    <form onSubmit={(e) => { e.preventDefault(); search.submit(q); }} className="relative" role="search">
      <input
        aria-label="Search mesh records"
        value={q}
        onChange={(e) => { clear(); setQ(e.target.value); }}
        onKeyDown={(e) => { if (e.key === "Escape") clear(); }}
        placeholder="search tx_id / account_id / round"
        className="w-full px-3 py-1.5 rounded bg-mesh-panel border border-transparent focus:border-mesh-accent outline-none text-sm"
      />
      {state.busy && (
        <span role="status" className="absolute right-2 top-1/2 -translate-y-1/2 text-mesh-mute text-xs">
          searching…
        </span>
      )}
      {(state.message || state.matches.length > 1) && (
        <div data-testid="search-results" className="absolute top-full left-0 right-0 mt-1 p-2 bg-mesh-panel border border-mesh-mute/30 text-xs rounded z-30 max-h-80 overflow-y-auto">
          <p role="status" className="text-mesh-mute px-1 py-1">
            {state.message ?? `${state.matches.length} matches — choose a record`}
          </p>
          {state.matches.map((match) => (
            <button
              type="button"
              key={`${match.kind}:${match.id}`}
              onClick={() => { clear(); onResult(match.kind, match.id); }}
              className="block text-left w-full p-2 rounded hover:bg-mesh-bg focus:bg-mesh-bg focus:outline focus:outline-mesh-accent break-all"
            >
              <span className="block text-mesh-mute">{match.kind === "tx" ? "transaction" : match.kind}</span>
              <span>{match.id}</span>
            </button>
          ))}
        </div>
      )}
    </form>
  );
}
